import { render, staticRenderFns } from "./ActivationListRow.vue?vue&type=template&id=1b5f4f4e&scoped=true&"
import script from "./ActivationListRow.vue?vue&type=script&lang=js&"
export * from "./ActivationListRow.vue?vue&type=script&lang=js&"
import style0 from "./ActivationListRow.vue?vue&type=style&index=0&id=1b5f4f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5f4f4e",
  null
  
)

export default component.exports